<template>
  <footer class="site-footer">
    <div class="footer-inner">
      <div class="footer-left">
        <div class="footer-logo">
          <img src="../assets/images/logo-transparent.png" alt="" />
        </div>
      </div>
      <div class="footer-right">
        <nav class="footer-nav">
          <router-link to="/explore">{{ $t("footer.explore") }}</router-link>
<!--          <router-link to="/open-access">{{ $t("footer.openAccess") }}</router-link>-->
          <router-link to="/about">{{ $t("footer.about") }}</router-link>
          <router-link to="/disclaimer">{{
            $t("footer.disclaimer")
          }}</router-link>
          <router-link to="/privacy">{{ $t("footer.privacy") }}</router-link>
        </nav>
        <div class="social-icons">
          <a
            v-for="item in socialLinks"
            :key="item.alt"
            :href="item.url"
            :aria-label="item.alt"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img :src="item.icon" :alt="item.alt" class="social-icon" />
          </a>
        </div>
        <p class="copyright">{{ $t("footer.copyright") }}</p>
      </div>
    </div>
  </footer>
</template>

<script>
import footerF from "@/assets/images/footer-f.png";
import footerInsta from "@/assets/images/footer2.png";
import footerYoutube from "@/assets/images/footer-video.png";
import footerX from "@/assets/images/footer-x.png";
import footerIn from "@/assets/images/footer-in.png";
import footerSina from "@/assets/images/footer-sina.png";
import footerWechat from "@/assets/images/footer-wechat.png";
import footerRed from "@/assets/images/footer-red.png";

export default {
  name: "SiteFooter",
  data() {
    return {
      socialLinks: [
        { alt: "Facebook", icon: footerF, url: "https://www.facebook.com/cityupress/" },
        { alt: "Instagram", icon: footerInsta, url: "https://www.instagram.com/cityupress/" },
        { alt: "YouTube", icon: footerYoutube, url: "https://www.youtube.com/user/CityUPressHK" },
        { alt: "X", icon: footerX, url: "https://x.com/CityU_Press" },
        { alt: "LinkedIn", icon: footerIn, url: "https://www.linkedin.com/company/city-university-of-hong-kong-press" },
        { alt: "Weibo", icon: footerSina, url: "https://weibo.com/cityupress" },
        { alt: "WeChat", icon: footerWechat, url: "https://www.cityu.edu.hk/upress/wechat" },
        { alt: "Xiaohongshu", icon: footerRed, url: "https://xhslink.com/m/3VxwMjXviL3" },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.site-footer {
  width: 100%;
  height: 254px;
  background: $footer-gradient;
  color: $white;
  margin-top: auto;
  padding: 66px 0 24px;
}

.footer-inner {
  max-width: $max-width;
  margin: 0 auto;
  padding: 0 24px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.footer-logo {
  display: flex;
  align-items: center;
  gap: 10px;
}

.footer-logo-text {
  display: flex;
  flex-direction: column;
  font-size: 13px;
  font-weight: 700;
  line-height: 1.4;

  .en {
    font-size: 11px;
    font-weight: 400;
    opacity: 0.9;
  }
}

.footer-right {
  text-align: right;
}

.footer-nav {
  display: flex;
  gap: 18px;
  margin-bottom: 16px;
  justify-content: flex-end;

  a {
    color: #fefefe;
    font-size: 16px;
    opacity: 0.9;
    transition: opacity 0.2s;

    &:hover {
      opacity: 1;
    }
  }
}

.social-icons {
  margin: 30px 0;
  justify-content: center;

  a {
    margin-left: 26px;
    color: $white;
    font-size: 20px;
    opacity: 0.9;
    transition: opacity 0.2s;

    &:hover {
      opacity: 1;
    }
  }
}
.social-icon {
  width: 24px;
  height: 24px;
  object-fit: contain;
  filter: brightness(0) invert(1); // 确保图标在深色背景上显示为白色
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.8;
  }
}

.copyright {
  font-size: 16px;
  opacity: 0.8;
  // text-align: center;
}
</style>